import { Grid, Grid2, TextField, Typography } from '@mui/material'; // Changed `Grid2` to `Grid` as `Grid2` isn't a default export
import React, { useEffect, useState } from 'react';
import { storage } from '../Config/Storage';
import Styles from '../Config/Styles';
import { useDispatch } from 'react-redux';
import { userupdate } from '../Redux/User/action';
import useDebounce from '../Config/Hooks'; // Import custom debounce hook
import Loader from '../Components/Loader';

const Info = () => {
    const dispatch = useDispatch();
    const [user, setUser] = useState({});
    const [loader, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState(""); // State for full name input
    const debouncedValue = useDebounce(inputValue, 500); // Debounced value of the input

    useEffect(() => {
        const loggedInUser = storage.fetch.loggedinuser();
        setUser(loggedInUser);
        setInputValue(`${loggedInUser?.first_name || ""}`);
    }, []);

    // Watch for debounced input value changes and trigger API call
    useEffect(() => {
        if (debouncedValue && debouncedValue !== `${user?.firstname || ""}`) {
            const first_name = debouncedValue;
            const data = { first_name };
            setLoading(true)
            dispatch(userupdate(data, { user_id: user?.id }, setLoading));
        }
    }, [debouncedValue, user, dispatch]);

    // Handle input change
    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    return (
        <Grid2 sx={{ p: 3 }}>
            <Grid2 item xs={12} sx={{ ...Styles.InfoStyle.grid, width: { xs: "100%", sm: "52%", md: "31.5%" } }}>
                <Loader open={loader} />
                <Typography variant="subtitle1">Full Name</Typography>
                <TextField
                    sx={Styles.InfoStyle.text}
                    value={inputValue}
                    onChange={handleChange}
                />
            </Grid2>
            <Grid2 item xs={12} sx={{ ...Styles.InfoStyle.grid, width: { xs: "100%", sm: "51%", md: "30.5%" }, mt: 2 }}>
                <Typography variant="subtitle1">Contact Number</Typography>
                <Typography variant="body1">+966 {user?.phone}</Typography>
            </Grid2>
        </Grid2>
    );
};

export default Info;
